var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(this.model)?_c('lead-form',{attrs:{"model":_vm.model,"isEdit":true},on:{"saved":_vm.saved}}):[_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1)],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }